/* ============================================================
   COLLECTION LOAD MORE
   Same behaviour as before (auto-click when the button scrolls
   into view, append the next page's cards, update the counter),
   now wrapped in a re-runnable init() so the style filter chips
   can call window.VeyonteLoadMore.init() after they swap the
   grid. Each init tears down the previous observer and click
   handler before binding to whatever is in the DOM now.
   ============================================================ */
(function () {
  var state = {
    button: null,
    observer: null,
    handler: null
  };

  // Helper: get unique product handles currently in the grid
  function getUniqueShownCount(productGrid) {
    // Prefer data attributes if your cards have them; fall back to href parsing
    var handles = new Set();

    // If your theme adds data-product-handle on each card, use that:
    productGrid.querySelectorAll("[data-product-handle]").forEach(function (el) {
      var h = el.getAttribute("data-product-handle");
      if (h) handles.add(h);
    });

    // Fallback: parse product handle from product links
    if (handles.size === 0) {
      productGrid.querySelectorAll('.product-card a[href*="/products/"]').forEach(function (a) {
        try {
          var url = new URL(a.href, window.location.origin);
          // /products/<handle> or /products/<handle>?...
          var parts = url.pathname.split("/");
          var idx = parts.indexOf("products");
          if (idx !== -1 && parts[idx + 1]) handles.add(parts[idx + 1]);
        } catch (e) {}
      });
    }

    // Last resort: count only top-level cards (avoids nested/placeholder nodes)
    if (handles.size === 0) {
      var topLevelCards = Array.from(productGrid.children).filter(function (n) {
        return (n.classList && n.classList.contains("product-card")) || (n.querySelector && n.querySelector(".product-card"));
      });
      return topLevelCards.length;
    }

    return handles.size;
  }

  function teardown() {
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }

    if (state.button && state.handler) {
      state.button.removeEventListener("click", state.handler);
    }

    state.button = null;
    state.handler = null;
  }

  function init() {
    teardown();

    var loadMoreBtn = document.querySelector(".js-load-more");
    var productGrid = document.querySelector("[data-product-grid]");
    var totalCountEl = document.getElementById("total-count");
    var shownCountEl = document.getElementById("shown-count");
    var progressBar = document.getElementById("progress-bar");
    var progressWrapper = document.getElementById("progress-wrapper");

    if (!productGrid) return;

    // Lock the total at the moment this grid was rendered
    var totalCount = parseInt((totalCountEl && totalCountEl.textContent) || "0", 10);

    function updateProgress() {
      var currentShown = getUniqueShownCount(productGrid);

      if (shownCountEl) shownCountEl.textContent = String(currentShown);
      if (totalCountEl) totalCountEl.textContent = String(totalCount);

      if (progressWrapper) progressWrapper.style.display = "block";

      if (progressBar && totalCount > 0) {
        var percent = Math.min((currentShown / totalCount) * 100, 100);
        progressBar.style.width = percent + "%";
        progressBar.style.display = "block";
      }
    }

    updateProgress(); // initial

    if (!loadMoreBtn) return;

    // ---- Infinite scroll trigger (auto-click when button hits viewport) ----
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && loadMoreBtn.isConnected) {
            loadMoreBtn.click();
          }
        });
      },
      { rootMargin: "300px 0px 0px 0px" } // preload before the button fully appears
    );
    io.observe(loadMoreBtn);

    var handler = function () {
      var nextUrl = loadMoreBtn.getAttribute("data-next-url");
      if (!nextUrl) return;

      loadMoreBtn.textContent = "Loading...";

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          // If the chips swapped the grid while this page was loading, drop the result
          if (!productGrid.isConnected) return;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newProductGrid = doc.querySelector("[data-product-grid]");
          var newCards = (newProductGrid && newProductGrid.querySelectorAll(".product-card")) || [];

          if (newCards.length === 0) {
            io.unobserve(loadMoreBtn);
            loadMoreBtn.remove();
            updateProgress();
            return;
          }

          newCards.forEach(function (card) { productGrid.appendChild(card); });

          // Update counts/progress AFTER append
          updateProgress();

          var nextBtn = doc.querySelector(".js-load-more");
          if (nextBtn && nextBtn.hasAttribute("data-next-url")) {
            loadMoreBtn.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
            loadMoreBtn.textContent = "Load more →";
          } else {
            // No next page
            io.unobserve(loadMoreBtn);
            loadMoreBtn.style.opacity = "0";
            setTimeout(function () { loadMoreBtn.remove(); }, 300);
          }
        })
        .catch(function (err) {
          console.error("Load more failed:", err);
          loadMoreBtn.textContent = "Error. Try again.";
        });
    };

    loadMoreBtn.addEventListener("click", handler);

    state.button = loadMoreBtn;
    state.observer = io;
    state.handler = handler;
  }

  window.VeyonteLoadMore = { init: init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();